import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { LEGAL_COOKIE_VERSION } from '../../constants';

const Cookies: React.FC = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: 760, mx: 'auto', py: { xs: 3, sm: 5 } }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
        Cookie Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Effective version: {LEGAL_COOKIE_VERSION}
      </Typography>
      <Divider sx={{ mb: 4 }} />

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>1. What We Use Cookies For</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We use essential cookies for authentication and secure session handling. These are required for the app to function.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>2. Optional Cookies</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        Optional categories (analytics and marketing) are disabled by default and remain blocked until you explicitly enable them.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>3. Your Control</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        You can accept all cookies, keep essential-only cookies, or change your selection later from Cookie Settings in the footer or Settings page.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>4. Withdraw Consent</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        You may withdraw optional cookie consent at any time. Essential cookies will remain active because they are required for login and security.
      </Typography>
    </Box>
  );
};

export default Cookies;
